import styled from "styled-components/macro";

export const GeneralContainer = styled.div(({ theme }) => ({
  margin: "20px 0",
}));

export const RadioButtonsContainer = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  marginTop: "10px",
  maxWidth: "600px",
  [theme.breakpoint.xl()]: {
    flexDirection: "row",
  },
}));

export const RadioButtonContainer = styled.label(({ theme }) => ({
  cursor: "pointer",
  [theme.breakpoint.xl()]: {
    margin: "20px 90px 30px 0",
  },
}));

export const RadioButtonControl = styled.span(({ theme }) => ({
  position: "relative",
  display: "inline-block",
  width: "20px",
  height: "20px",
  margin: "2px",
  verticalAlign: "middle",
  border: `2px solid ${theme.color.neutral["04"]}`,
  bottom: "5px",
  borderRadius: "200px",
}));

export const RadioButtonArea = styled.span(({ theme, checked }) => ({
  backgroundColor: checked ? theme.color.brandPrimary.light : "inherit",
  marginRight: "10px",
  padding: "1px 0",
  borderRadius: "200px",
}));

export const StyledInput = styled.input(({ theme }) => ({
  boxSizing: "border-box",
  padding: "0",
  opacity: "0",
  position: "absolute",
  fontSize: "1rem",
  lineHeight: "1.5",
  borderRadius: "0",
  outline: "0",
  display: "none",
}));

export const RadioButtonLabel = styled.span(({ theme }) => ({
  fontSize: "16px",
  lineHeight: "27px",
  [theme.breakpoint.xl()]: {
    fontSize: "18px",
  },
}));

export const ErrorMessage = styled.h6(({ theme }) => ({
  textAlign: "inherit",
  display: "flex",
  alignItems: "center",
  svg: {
    margin: "0 5px",
    width: "1rem",
  },
  color: theme.color.feedback.error,
  marginTop: 0,
  marginBottom: "32px",
  fontSize: "14px",
  fontWeight: "500",
  lineHeight: "150%",
}));
